module.exports = __webpack_public_path__ + "img/logo-spruge-meadows.7d5e3121.jpg";